﻿{
  "version": 1,
  "gameId": "mafia",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0 },
  "cosmetics": {},
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "mafia.rules.navigationLabel",
    "kickerKey": "mafia.rules.kicker",
    "titleKey": "mafia.rules.title",
    "summaryKey": "mafia.rules.summary",
    "sections": [
      { "id": "setup", "key": "mafia.rules.setup" },
      { "id": "reveal", "key": "mafia.rules.reveal" },
      { "id": "night", "key": "mafia.rules.night" },
      { "id": "day", "key": "mafia.rules.day" },
      { "id": "vote", "key": "mafia.rules.vote" },
      { "id": "finish", "key": "mafia.rules.finish" }
    ],
    "settingsAccess": false
  }
}
